import React from 'react';
import {Atom, Plugins} from '@packages/systems/wfdl';
import {WF_BINDING_DATA_KEY} from '@packages/systems/commerce/constants';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

const CommerceCheckoutOrderItemOptionListItemValue = Atom.createRender(
  (props) => {
    const {attributes, classes, context, generateAttributes, innerHTML} = props;
    const value = context.get('value', '');
    const newAttributes = {
      ...generateAttributes(attributes, classes),
      [WF_BINDING_DATA_KEY]: encodeURIComponent(
        JSON.stringify([
          {
            innerHTML: {
              type: 'CommercePropValues',
              filter: {type: 'identity', params: []},
              dataPath: context.get('bindingPathPrefix', []).join('.'),
            },
          },
        ])
      ),
    } as const;
    return (
      <span {...newAttributes}>
        {innerHTML
          ? // TODO (platform): fix innerHTML type issues

            innerHTML
          : value}
      </span>
    );
  }
);

const config = createIntegratedAtom({
  showEmpty: false,
  displayName: 'Text Block',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Text')),
  },
  constraints: {
    pinToParent: true,
    ancestors: [
      {
        is: 'CommerceCheckoutOrderItemOptionListItem',
        rule: 'ExactlyOne',
      },
    ],
  },
  render: CommerceCheckoutOrderItemOptionListItemValue,
  fields: {},
});

export default config;
